export default class MisconfigurationError extends Error {
};
